/**
 * 删除
 */
import React from 'react';
import { Modal, message } from 'antd';
import PropTypes from 'prop-types';
import styles from './DeleteModal.module.scss';
import http from '@/assets/api/http';
import { ExclamationCircleOutlined } from '@ant-design/icons';


const { confirm } = Modal;

class DeleteModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    _handleOk = () => {
        const { data, } = this.props;
        http('/?cmd=com.xqxc.api.pig.mis.biz.user.marketing.CouponMisService.deleteCoupon', {
            id: data,
        }, 'POST').then(() => {
            message.success('删除成功');
            this.props.closeMode(true);
        }).catch((e = {}) => {
            message.error(e.message || '修改异常');
        });
    }

    _handleCancel = () => {
        this.props.closeMode();
    }

    showConfirm = () => {
        let that = this;
        confirm({
            destroyOnClose: true,
            centered: true,
            title: '温馨提示',
            icon: <ExclamationCircleOutlined />,
            okType: 'danger',
            content: <>
                <div className={styles.container}>
                    删除后将您将无法再看到该张券信息，用户已经领取成功的券不影响使用，是否确认删除？
                </div>
            </>,
            onOk() {
                that._handleOk();
            },
            onCancel() {
                that._handleCancel();
            },
        });
    }


    render() {
        return <>{this.showConfirm()}</>;
    }
}

DeleteModal.propTypes = {
    data: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]), // 弹框入参
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
};

export default DeleteModal;